<template>
	<div class="commission-manager">
		<el-form :inline="true">
			<el-form-item>
				<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
			</el-form-item>
		</el-form>
		
		<!-- 提成配置列表 -->
		<el-table
				:data="commissionList"
				border
				stripe
				@current-change="selectCurrentRow"
				style="width: 100%; margin-top: 20px"
				row-key="id"
		>
			<el-table-column prop="number" label="编号" width="100" header-align="center" align="center"/>
			<el-table-column prop="typeName" label="提成类型名称" min-width="280" header-align="center" align="center" />
			<el-table-column prop="commissionStructure" label="提成方式" width="130" header-align="center" align="center">
				<template #default="scope">
					<!-- 后端 1=固定提成 2=百分比提成 转文字 -->
					{{ scope.row.commissionStructure == 1 ? '固定提成' : scope.row.commissionStructure == 2 ? '比例提成' : '-' }}
				</template>
			</el-table-column>
			<el-table-column prop="fixedValue" label="固定值" width="150" header-align="center" align="center" />
			<el-table-column prop="ratioValue" label="比例值" width="150" header-align="center" align="center">
				<template #default="scope">
					<!-- 百分比展示格式化，空值显示- -->
					{{ scope.row.ratioValue ? scope.row.ratioValue + '%' : '-' }}
				</template>
			</el-table-column>
			<el-table-column prop="createUserName" label="创建人" width="120" header-align="center" align="center" />
			<el-table-column prop="createTime" label="创建时间" width="200" header-align="center" align="center" />
			<el-table-column prop="updateUserName" label="修改人" width="120" header-align="center" align="center" />
			<el-table-column prop="updateTime" label="修改时间" width="200" header-align="center" align="center" />
			<el-table-column prop="isEnable" label="是否启用" width="120" header-align="center" align="center">
				<template #default="scope">
					<el-tag :type="scope.row.isEnable ? 'success' : 'info'">
						{{ scope.row.isEnable ? '已启用' : '未启用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="enableTime" label="生效时间" width="200" header-align="center" align="center" />
			
<!--			<el-table-column label="操作" width="140">-->
<!--				<template #default="scope">-->
<!--					<el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>-->
<!--				</template>-->
<!--			</el-table-column>-->
		</el-table>
		
		<!-- 新增/编辑弹窗 -->
		<el-dialog
				:title="dialogTitle"
				:visible.sync="dialogVisible"
				width="50%"
				destroy-on-close
				:close-on-click-modal="false"
		>
			<el-form
					:model="formData"
					:rules="formRules"
					ref="formRef"
					label-width="130px"
			>
				<el-form-item label="编号" prop="number">
					<el-input
							v-model.number="formData.number"
							placeholder="请输入编号"
							style="width: 60%"
					/>
				</el-form-item>
				
				<el-form-item label="提成类型名称" prop="typeName">
					<el-input
							v-model="formData.typeName"
							placeholder="请输入提成类型名称"
							style="width: 80%"
							type="textarea"
							:rows="2"
					/>
				</el-form-item>
				
				<el-form-item label="提成方式" prop="commissionStructure">
					<el-select
							v-model="formData.commissionStructure"
							placeholder="请选择提成方式"
							style="width: 80%"
					>
						<el-option label="固定提成" :value="1" />
						<el-option label="比例提成" :value="2" />
					</el-select>
				</el-form-item>
				
				<el-form-item label="固定值" prop="fixedValue" v-if="formData.commissionStructure==1">
					<el-input
							v-model.number="formData.fixedValue"
							placeholder="固定提成填写，比例提成可为空"
							style="width: 80%"
					/>
				</el-form-item>
				
				<el-form-item label="比例值" prop="ratioValue" v-if="formData.commissionStructure==2">
					<el-input
							v-model.number="formData.ratioValue"
							placeholder="比例提成填写数字，无需%，固定提成为空"
							style="width: 80%"
					/>
				</el-form-item>
				
				<el-form-item label="是否启用" prop="isEnable">
					<el-switch
							v-model="formData.isEnable"
							active-text="已启用"
							inactive-text="未启用"
							:active-value="true"
							:inactive-value="false"
					/>
				</el-form-item>
				
<!--				<el-form-item label="生效时间" prop="enableTime">-->
<!--					<el-date-picker-->
<!--							v-model="formData.enableTime"-->
<!--							type="datetime"-->
<!--							placeholder="选择生效时间"-->
<!--							style="width: 80%"-->
<!--							value-format="yyyy-MM-dd HH:mm:ss"-->
<!--					/>-->
<!--				</el-form-item>-->
			
			</el-form>
			<template #footer>
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// 引入你原有接口，方法名保持和你原来一致，内部参数已适配
import {
	getCarouselInformationList,
	addCarouselInformation,
	updateCarouselInformation,
	deleteCarouselInformation, getCommissionBasisList, addCommissionBasis, updateCommissionBasis
} from "../../api/api";
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
export default {
	components: { Toolbar },
	name: "CommissionManager",
	data() {
		return {
			buttonList: [],
			// 列表数据
			commissionList: [],
			// 弹窗
			dialogVisible: false,
			dialogTitle: "",
			formRef: null,
			// 【完全匹配后端返回字段】
			formData: {
				id: undefined,
				number: undefined,
				typeName: "",
				commissionStructure: "", // 1固定 2百分比
				fixedValue: null,
				ratioValue: null,
				isEnable: true,
				enableTime: undefined,
				isDeleted: undefined,
				createTime: undefined,
				updateTime: undefined,
				createUserId: undefined,
				createUserName: undefined,
				updateUserId: undefined,
				updateUserName: undefined
			},
			// 校验规则
			formRules: {
				number:[
					{ required: true, message: "请输入编号", trigger: "blur" }
				],
				typeName: [
					{ required: true, message: "请输入提成类型名称", trigger: "blur" }
				],
				commissionStructure: [
					{ required: true, message: "请选择提成方式", trigger: "change" }
				],
				fixedValue:[
					{ required: true, message: "请输入固定值", trigger: "blur" }
				],
				ratioValue:[
					{ required: true, message: "请输入比例值", trigger: "blur" }
				]
			},
			// 选中行
			needData: null,
			// 查询条件
			filters: {
				typeName: ""
			}
		};
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	methods: {
		
		// 表格选中行
		selectCurrentRow(val) {
			this.needData = val;
		},
		//获取列表数据
		getListData(){
			this.getList();
		},
		// 获取列表(沿用你原接口方法，无需修改文件引入)
		getList() {
			let params = {
				typeName: this.filters.typeName
			};
			getCommissionBasisList(params).then(res => {
				this.commissionList = res.data.response || [];
			}).catch(() => {
				this.$message.error("列表加载失败");
			});
		},
		// 工具栏调用
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		// 新增
		handleAdd() {
			this.dialogTitle = "新增提成配置";
			this.resetForm();
			this.dialogVisible = true;
		},
		// 编辑
		handleEdit() {
			if (!this.needData) {
				this.$message.error("请选择要编辑的数据！");
				return;
			}
			this.dialogTitle = "编辑提成配置";
			this.formData = JSON.parse(JSON.stringify(this.needData));
			this.dialogVisible = true;
		},
		// 删除
		handleDel() {
			if (!this.needData) {
				this.$message.error("请选择要删除的数据！");
				return;
			}
			this.$confirm("此操作将删除该配置, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				deleteCarouselInformation({ id: this.needData.id }).then(res => {
					if (res.data.success) {
						this.$message.success("删除成功");
						this.getList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			}).catch(() => {
				this.$message.info("已取消删除");
			});
		},
		// 重置表单
		resetForm() {
			this.formData = {
				id: undefined,
				number: undefined,
				typeName: "",
				commissionStructure: undefined ,
				fixedValue: null,
				ratioValue: null,
				isEnable: true,
				enableTime: undefined,
				isDeleted: undefined,
				createTime: undefined,
				updateTime: undefined,
				createUserId: undefined,
				createUserName: undefined,
				updateUserId: undefined,
				updateUserName: undefined
			};
			if (this.formRef) {
				this.formRef.resetFields();
			}
		},
		// 保存
		handleSave() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					// 编辑保存
					if (this.formData.id) {
						updateCommissionBasis(this.formData).then(res => {
							if (res.data.success) {
								this.$message.success("修改成功");
								this.getList();
								this.dialogVisible = false;
							} else {
								this.$message.error(res.data.message);
							}
						});
					} else {
						// 新增保存
						addCommissionBasis(this.formData).then(res => {
							if (res.data.success) {
								this.$message.success("新增成功");
								this.getList();
								this.dialogVisible = false;
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				}
			});
		}
	},
	mounted() {
			useEnterSearch(() => {
			this.getListData();
		});
		let routers = window.localStorage.router
				? JSON.parse(window.localStorage.router)
				: [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getList();
	}
};
</script>

<style scoped>
.commission-manager {
	padding: 20px;
}
::v-deep .el-textarea__inner {
	resize: none;
}
</style>